<div [ngClass]="{ hidden: !(loading$ | async) }" class="tw-progress-bar">
  <div class="fixed w-screen">
    <div class="tw-shim">
      <div [ngStyle]="{ 'width.%': progressBarPercentage}" class="completed"></div>
    </div>
  </div>
</div>